import axios from '@/shared/utils/axios-init';

/* eslint-disable */

const initialState = {
  data: [],
};

const getters = {
  getTableData: (state) => state.data,
};

const actions = {
  async fetchTableData({ commit }) {
    try {
      const { data } = await axios.get('currencies/formain');
      commit('setTableData', data.curstats);
    } catch (e) {
      console.log(e);
    }
  },
};

const mutations = {
  setTableData(state, payload) {
    state.data = payload;
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/Home/modules/table.js